import Backbone from "backbone";

class BreadcrumbModel extends Backbone.Model {}

export default BreadcrumbModel;
